"use client";

import React from "react";
import { Globe, Truck, ChartLine, FileCheck, Warehouse, Ship } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  title: "International Logistics",
  description: "Strategic cross-border transport architectures ensuring seamless global movement of high-value assets with clinical precision.",
  icon: Globe
}, {
  title: "Market Entry",
  description: "Precision-engineered entry strategies for complex international territories, focused on rapid dominance and local authority.",
  icon: ChartLine
}, {
  title: "Digital Localized Development",
  description: "Bespoke digital infrastructure designed for local market penetration and search engine dominance within target regions.",
  icon: FileCheck
}, {
  title: "Export Architecture",
  description: "Custom-built frameworks for international trade, optimizing compliance and cross-border operational flow for maximum efficiency.",
  icon: Truck
}, {
  title: "Tactical Infrastructure",
  description: "Strategic deployment of physical and digital assets to secure competitive advantages in complex emerging markets.",
  icon: Warehouse
}, {
  title: "Venture Coordination",
  description: "Active oversight and strategic management of international logistical and digital holdings under Geroi.eu management.",
  icon: Ship
}];
export default function ComprehensiveTradeSolutions() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="116468" id="our-strategic-specialists" className="bg-background text-foreground py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {}
        <div ref={headerRef} className={`mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-[45px] font-serif font-bold text-foreground uppercase tracking-wider leading-tight w-fit border-b-[3px] border-primary pb-2 mb-6">
            Our Strategic Specialists
          </h2>
          <p className="text-base font-sans text-muted-foreground max-w-3xl leading-relaxed">
            Integrated solutions for seamless expansion. Discover our comprehensive range of services designed to dominate complex international markets.
          </p>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 ease-out delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {servicesData.map((service, index) => {
          const Icon = service.icon;
          return <div data-index={index} key={index}>
                <Card className="h-full bg-card/40 backdrop-blur-[12px] border border-white/50 rounded-lg p-8 shadow-sm hover:shadow-[0px_0px_20px_rgba(59,130,246,0.2)] transition-all duration-300 group">
                  <CardHeader className="p-0 mb-4">
                    <div className="mb-6 inline-flex items-center justify-center">
                      <Icon className="size-12 text-primary group-hover:-translate-y-1 transition-transform duration-300" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-[20px] font-serif font-bold text-foreground uppercase tracking-wide">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="p-0">
                    <p className="text-[14px] font-sans text-muted-foreground leading-relaxed">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

      </div>
    </section>;
}